<template>
	<div>
		<aBox>
			<div slot="body">
				<osFilter ref="filter" @updateTab="filter" />
			</div>
		</aBox>

		<aBox title="Ordem de serviços">
			<div slot="body">
				<sTable
					ref="tab"
					action-read="private-read-sstSupervisao"
					:table-striped="false"
					:table-hover="false"
					:functions="functions"
					:labels="labels"
					:line-status="fxStatus"
					:block="true"
					@settings_os="(r) => $refs.compForm.open(r)"
				/>
				<!-- :actions='actions' -->
			</div>
		</aBox>
		<CmpForm ref="compForm" @updateTable="$refs.tab.updateTable()" />
	</div>
</template>
<script>
	import aBox from 'box';
	import sTable from 'table';
	import eDate from 'js/date';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import { mapState } from 'vuex';
	import loader from './loader.js';

	import osFilter from './components/filter.vue';
	import CmpForm from './components/comp.forms.vue';
	import TmpActions from './components/tmp.actions.vue';
	// import cmpActions from "./components/actions.vue"

	export default {
		name: 'MainServiceOrder',
		components: {
			aBox,
			sTable,
			osFilter,
			CmpForm,
		},
		provide() {
			let assets = {};
			for (let asset in this.assets) {
				Object.defineProperty(assets, asset, {
					enumerable: true,
					get: () => this.assets[asset],
				});
			}
			return {
				assets: assets,
				update: () => {
					return this.$refs.tab.updateTable();
				},
			};
		},
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Status' },
					{
						data: ['dInicio', 'duracao'],
						icon: [
							'fa fa-calendar-check-o',
							'fa fa-calendar-times-o',
						],
						label: 'Previsão',
						two: true,
					},
					{
						data: ['dComeco', 'dTermino'],
						icon: [
							'fa fa-calendar-check-o',
							'fa fa-calendar-times-o',
						],
						label: 'Execução',
						two: true,
					},
					{
						data: ['dComecoUid', 'dTerminoUid'],
						icon: [
							'fa fa-calendar-check-o',
							'fa fa-calendar-times-o',
						],
						label: 'Responsável',
						two: true,
					},
					{
						data: ['servico', 'tarefa'],
						label: 'Serviço/Tarefa',
						two: true,
					},
					{ data: ['cliente', 'cnpj'], label: 'Cliente', two: true },
					{ data: 'depto.titulo', label: 'Depto' },
					{
						data: ['cnpj.client_data.regiao'],
						label: 'Região' /*two: true*/,
					},
				],
				functions: [
					{ cod: 'dInicio', fx: this.eDate },
					{ cod: 'dComeco', fx: this.eDate },
					{ cod: 'dTermino', fx: this.eDate },
					{ cod: 'duracao', fx: this.eDate },
					{ cod: 'cnpj', fx: this.get_cnpj },
					{ cod: 'cod', fx: this.getStatus },
					{ cod: 'dComecoUid', fx: this.get_resp_comeco },
					{ cod: 'dTerminoUid', fx: this.get_resp_termino },
				],
				// actions: cmpActions,
				assets: {
					enquadramento_cipa: null,
					grupos: null,
					relacionamento_cnae_cipa: null,
					grau_de_risco: null,
					tecnicos: null,
					sForms: null,
					deptos: null,
				},
			};
		},

		computed: {
			...mapState({
				depto: (s) => s.user_data.uid.departamento,
			}),
		},

		mounted() {
			// var directories = path.dirname('./actions.vue');
			// console.log(__dirname)
			this.$refs.filter.update();
			this.$emit('setHeader', ['Ordem de serviço', '']);
			WBS.send('protected-read-assetsMdMapeamento', (resp) => {
				if (resp.status == 'success') {
					this.assets = resp.data;
				}
			});
		},

		methods: {
			get_resp_comeco(t) {
				if (t.user.length == 0) return '';
				else return t.user;
			},
			get_resp_termino(t) {
				if (t.user.length == 0) return '';
				else return t.user;
			},
			get_cnpj(t) {
				if (Array.isArray(t.type)) return t.client_data.cnpj;
				else return t.sst_data.cnpj;
			},
			filter(val) {
				this.$refs.tab.setFilter(val);
				this.$refs.tab.updateTable();
			},
			eDate(val) {
				if (val == '0000-00-00 00:00:00' || val == null) {
					return '--/--/--';
				} else {
					return eDate(val, 'DD/MM/YY');
				}
			},

			getStatus(val, row) {
				return `<span title="ID:${val} ${this.fxStatus(
					row
				).toUpperCase()}" class="bola-de-status-da-os"></span>`;
			},
			fxStatus(row) {
				if (row.contrato.status == 'suspenso') return 'os-suspensa';
				let status = [];
				let hoje = new Date();
				let iniPrev = new Date(row.dInicio);
				let fimPrev = new Date(row.duracao);
				let iniReal = new Date(row.dComeco);
				let fimReal = new Date(row.dTermino);

				if (row.status == 0 && hoje < iniPrev) status.push('os-nova');

				if (row.status == 0 && hoje > iniPrev)
					status.push('os-com-atraso-para-iniciar');
				if (row.status == 0 && hoje > fimPrev)
					status.push('os-atrasada-para-finalizar');

				if (row.status == 1 && iniReal > iniPrev)
					status.push('os-iniciada-com-atraso');
				if (row.status == 1 && iniReal < iniPrev)
					status.push('os-iniciada-dentro-do-prazo');
				if (row.status == 1 && hoje > fimPrev)
					status.push('os-atrasada-para-finalizar');
				if (row.status == 1 && hoje < fimPrev)
					status.push('os-aguardando-termino');

				if (row.status == 2 && iniReal > iniPrev)
					status.push('os-iniciada-com-atraso');
				if (row.status == 2 && iniReal < iniPrev)
					status.push('os-iniciada-dentro-do-prazo');

				if (row.status == 2 && fimReal > fimPrev)
					status.push('os-finalizada-com-atraso');
				if (row.status == 2 && fimReal < fimPrev)
					status.push('os-finalizada-dentro-do-prazo');

				return status.join(' ');
			},
			// toggleStatus(id, cod_contrato, status){
			// 	let sData = {status: status, cod: id, cod_contrato:cod_contrato}
			// 	WBS.send('private-custom-toggleStatusOS', sData, resp => {
			// 		console.log(resp)
			// 		// if(resp.status == "success"){
			// 		// 	toastr.success('Status alterado com sucesso!')
			// 		// 	this.$refs.tab.updateTable()
			// 		// }else{
			// 		// 	toastr.error(resp.msgs[0])
			// 		// 	console.log(resp)
			// 		// }
			// 	})
			// }
		},
	};
</script>
<style>
	.bola-de-status-da-os {
		width: 27px;
		height: 27px;
		display: block;
		background: #cecece;
		margin: 0 auto;
		cursor: pointer;
		border-radius: 27px;
	}

	.os-iniciada-dentro-do-prazo .bola-de-status-da-os {
		background-color: green;
	}

	.os-iniciada-com-atraso .bola-de-status-da-os,
	.os-com-atraso-para-iniciar .bola-de-status-da-os {
		background-color: red;
	}

	.os-finalizada-dentro-do-prazo {
		background-color: rgba(0, 128, 0, 0.15);
	}
	.os-aguardando-termino {
		background-color: rgba(47, 150, 173, 0.15);
	}

	.os-atrasada-para-finalizar,
	.os-finalizada-com-atraso {
		background-color: rgba(255, 0, 0, 0.15);
	}
</style>



// WEBPACK FOOTER //
// src/components/supervisao/index.vue